<template>
  <main class="max-w-[1200px] mx-auto mb-20 px-5">
    <h1 class="font-bold text-center my-8">접수·결제정보</h1>

    <div class="w-full overflow-auto lg:my-4 py-4 max-lg:px-4">
      <div class="flex w-fit gap-x-2">
        <router-link
          to="/profile/confList"
          target="_blank"
          class="sec_btn py-2 px-4 rounded-full whitespace-nowrap max-lg:text-sm"
        >
          컨퍼런스 신청내역
          <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" />
        </router-link>
        <router-link
          to="/mypage/list"
          active-class="pri_btn"
          class="sec_btn py-2 px-4 rounded-full whitespace-nowrap max-lg:text-sm"
        >
          주문내역
        </router-link>
        <router-link
          to="/mypage/paymentList"
          active-class="pri_btn"
          class="sec_btn py-2 px-4 rounded-full whitespace-nowrap max-lg:text-sm"
        >
          결제 내역
        </router-link>
      </div>
    </div>

    <div class="max-lg:px-5 text-sm">
      <div class="bg-neutral-100 border border-neutral-200 p-4 mt-2">
        <div class="lg:flex items-center">
          <span class="w-20">기간조회</span>

          <div class="flex">
            <VDatePicker
              v-model.range="range"
              locale="ko"
              :max-date="new Date()"
            >
              <template #default="{ inputValue, inputEvents }">
                <div class="flex justify-center items-center">
                  <input
                    type="text"
                    class="regi_inputs w-full"
                    :value="inputValue.start"
                    v-on="inputEvents.start"
                  />
                  <span class="mx-2">~</span>
                  <input
                    type="text"
                    class="regi_inputs w-full"
                    :value="inputValue.end"
                    v-on="inputEvents.end"
                  />
                  <button
                    class="ml-2 sec_filled-blk_btn p-2 md:w-40"
                    type="button"
                    @click="getMyOrderList(1)"
                  >
                    조회
                  </button>
                </div>
              </template>
            </VDatePicker>
          </div>
        </div>

        <!-- <div class="lg:flex my-4">
          <span class="w-20">구분</span>
          <div class="flex flex-wrap items-center gap-2">
            <label  class="check_btn gap-1">
              <input type="checkbox"/>
              전체
            </label>
            <label  class="check_btn gap-1">
              <input type="checkbox"/>
              결제 대기
            </label>
            <label  class="check_btn gap-1">
              <input type="checkbox"/>
              결제 완료
            </label>
            <label  class="check_btn gap-1">
              <input type="checkbox"/>
              결제 취소
            </label>
          </div>
        </div>
  
        <div class="lg:flex ">
          <span class="w-20">검색</span>
          <div class="flex gap-2 items-center">
            <select name="" id="" class="max-lg:hidden">
              <option value="">전체</option>
              <option value="">콘텐츠명</option>
            </select>
            <input type="text" placeholder="검색어를 입력하세요" class="max-lg:w-[55vw]"/>
            <button type="button" class="sec_btn px-5 py-1">조회</button>
          </div>
        </div> -->
      </div>
    </div>

    <div
      class="mt-10 max-lg:px-5 max-lg:overflow-auto"
      style="max-width: calc(100vw - 2.5rem)"
    >
      <div class="table_grid_container">
        <table
          class="table_grid_wrapper max-lg:min-w-min"
          v-if="$route.path === '/mypage/list'"
          style="max-width: calc(100vw - 5rem)"
        >
          <tr class="table_grid_header max-lg:!hidden">
            <th>주문정보</th>
            <th>결제정보</th>
            <th>주문상세</th>
            <th>영수증</th>
          </tr>

          <tr
            class="table_grid_body max-lg:grid"
            v-for="item in myOrderList"
            :key="item.oid"
          >
            <td>
              <div class="text-left">
                <p class="font-bold">{{ item.oid }}</p>
                <p class="text-lg">{{ item.goodname }}</p>
                <p class="text-gray-400">{{ formDate(item.confirm_date) }}</p>
              </div>
            </td>
            <td class="max-lg:!p-0">
              <p>
                <b class="text-lg">{{
                  item.totalPaidAmount.toLocaleString()
                }}</b
                >원
              </p>
              <p class="text-base" v-if="item.totalPaidAmount > 0">
                {{
                  item.gopaymethod === "Card"
                    ? "카드결제"
                    : item.gopaymethod === "VCard"
                    ? "ISP 결제"
                    : item.gopaymethod === "DirectBank"
                    ? "실시간 계좌이체"
                    : item.gopaymethod === "VBank"
                    ? "가상계좌(무통장입금)"
                    : ""
                }}
                <span
                  :class="{
                    'text-red-500': item.orderStatus === 'PAY_FAIL',
                    'text-gray-400': item.orderStatus === 'ORDER_DONE',
                  }"
                >
                  [{{
                    item.orderStatus === "PAY_WAIT"
                      ? "결제 대기"
                      : item.orderStatus === "VBANK_WAIT"
                      ? "가상계좌 입금 대기"
                      : item.orderStatus === "PAY_FAIL"
                      ? "결제 실패"
                      : item.orderStatus === "ORDER_DONE"
                      ? "결제 완료"
                      : item.orderStatus === "REFUNDED"
                      ? "환불 완료"
                      : ""
                  }}]
                </span>
              </p>
            </td>
            <td class="max-lg:!p-0">
              <router-link
                v-if="item.totalPaidAmount > 0"
                :to="'/mypage/detail/' + item.oid"
                type="button"
                class="flex items-center justify-center max-lg:border py-3"
              >
                상세보기
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="20" height="20" fill="white" />
                  <path
                    d="M6.74999 15C6.74952 14.9015 6.76874 14.8038 6.80652 14.7128C6.8443 14.6218 6.89988 14.5392 6.96999 14.47L11.44 9.99999L6.99999 5.52999C6.9086 5.38904 6.86718 5.22148 6.88237 5.05418C6.89755 4.88687 6.96847 4.72951 7.08375 4.60731C7.19903 4.48512 7.35199 4.40516 7.51813 4.38026C7.68427 4.35536 7.85395 4.38696 7.99999 4.46999L13 9.47C13.1404 9.61062 13.2193 9.80124 13.2193 9.99999C13.2193 10.1987 13.1404 10.3894 13 10.53L7.99999 15.53C7.85936 15.6704 7.66874 15.7493 7.46999 15.7493C7.27124 15.7493 7.08061 15.6704 6.93999 15.53C6.8093 15.3853 6.74101 15.1948 6.74999 15Z"
                    fill="black"
                  />
                </svg>
              </router-link>
            </td>
            <td class="max-lg:!px-0">
              <a
                v-if="item.totalPaidAmount > 0"
                :href="
                  'https://iniweb.inicis.com/receipt/iniReceipt.jsp?noTid=' +
                  item.tid
                "
                target="_blank"
                class="flex items-center justify-center max-lg:border py-3"
              >
                <span class="lg:hidden">영수증 출력</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="20" height="20" fill="white" />
                  <path
                    d="M3.70001 5.50001C3.70001 5.02262 3.88965 4.56479 4.22722 4.22722C4.56479 3.88965 5.02262 3.70001 5.50001 3.70001H11.8C12.2774 3.70001 12.7352 3.88965 13.0728 4.22722C13.4104 4.56479 13.6 5.02262 13.6 5.50001V11.8H16.3V13.6C16.3 14.3161 16.0155 15.0029 15.5092 15.5092C15.0029 16.0155 14.3161 16.3 13.6 16.3H6.40001C5.68393 16.3 4.99717 16.0155 4.49082 15.5092C3.98448 15.0029 3.70001 14.3161 3.70001 13.6V5.50001ZM13.6 12.7V15.4C14.0774 15.4 14.5352 15.2104 14.8728 14.8728C15.2104 14.5352 15.4 14.0774 15.4 13.6V12.7H13.6ZM12.7 15.4V5.50001C12.7 5.26132 12.6052 5.0324 12.4364 4.86362C12.2676 4.69483 12.0387 4.60001 11.8 4.60001H5.50001C5.26132 4.60001 5.0324 4.69483 4.86362 4.86362C4.69483 5.0324 4.60001 5.26132 4.60001 5.50001V13.6C4.60001 14.0774 4.78965 14.5352 5.12722 14.8728C5.46479 15.2104 5.92262 15.4 6.40001 15.4H12.7ZM6.40001 6.85001C6.40001 6.73066 6.44742 6.61621 6.53181 6.53181C6.61621 6.44742 6.73066 6.40001 6.85001 6.40001H10.45C10.5694 6.40001 10.6838 6.44742 10.7682 6.53181C10.8526 6.61621 10.9 6.73066 10.9 6.85001C10.9 6.96936 10.8526 7.08382 10.7682 7.16821C10.6838 7.2526 10.5694 7.30001 10.45 7.30001H6.85001C6.73066 7.30001 6.61621 7.2526 6.53181 7.16821C6.44742 7.08382 6.40001 6.96936 6.40001 6.85001ZM6.40001 9.55001C6.40001 9.43067 6.44742 9.31621 6.53181 9.23181C6.61621 9.14742 6.73066 9.10001 6.85001 9.10001H10.45C10.5694 9.10001 10.6838 9.14742 10.7682 9.23181C10.8526 9.31621 10.9 9.43067 10.9 9.55001C10.9 9.66936 10.8526 9.78382 10.7682 9.86821C10.6838 9.9526 10.5694 10 10.45 10H6.85001C6.73066 10 6.61621 9.9526 6.53181 9.86821C6.44742 9.78382 6.40001 9.66936 6.40001 9.55001ZM6.40001 12.25C6.40001 12.1307 6.44742 12.0162 6.53181 11.9318C6.61621 11.8474 6.73066 11.8 6.85001 11.8H8.65001C8.76936 11.8 8.88382 11.8474 8.96821 11.9318C9.0526 12.0162 9.10001 12.1307 9.10001 12.25C9.10001 12.3694 9.0526 12.4838 8.96821 12.5682C8.88382 12.6526 8.76936 12.7 8.65001 12.7H6.85001C6.73066 12.7 6.61621 12.6526 6.53181 12.5682C6.44742 12.4838 6.40001 12.3694 6.40001 12.25Z"
                    fill="black"
                  />
                </svg>
              </a>
            </td>
          </tr>
        </table>

        <table
          class="table_grid_wrapper"
          v-if="$route.path === '/mypage/paymentList'"
        >
          <tr class="table_grid_header">
            <th>거래번호</th>
            <th>결제일시</th>
            <th>결제금액</th>
            <th>결제수단</th>
            <th>상태</th>
            <th>결제기기</th>
          </tr>

          <tr
            class="table_grid_body"
            v-for="item in myOrderList"
            :key="item.oid"
          >
            <td>{{ item.tid }}</td>
            <td>{{ formDate(item.confirm_date) }}</td>
            <td>{{ item.totalPaidAmount.toLocaleString() }}원</td>
            <td>{{ item.gopaymethod }}</td>
            <td>
              {{
                item.orderStatus === "PAY_WAIT"
                  ? "결제 대기"
                  : item.orderStatus === "VBANK_WAIT"
                  ? "가상계좌 입금 대기"
                  : item.orderStatus === "PAY_FAIL"
                  ? "결제 실패"
                  : item.orderStatus === "ORDER_DONE"
                  ? "결제 완료"
                  : item.orderStatus === "REFUNDED"
                  ? "환불 완료"
                  : ""
              }}
            </td>
            <td>{{ item.pay_device }}</td>
          </tr>
        </table>
      </div>

      <pagination
        v-if="pageInfo.page"
        :pageInfo="pageInfo"
        :page="page"
        :size="size"
        @updatePage="updatePage"
      />
    </div>
  </main>
</template>

<script setup>
import axios from "axios";
import { onMounted, ref, computed } from "vue";
import Pagination from "@/components/Pagination.vue";
import { formDate } from "@/assets/js/util.js";

const formatDate = (date) => date.toISOString().split("T")[0];

const start = new Date();
const end = new Date();
start.setDate(end.getDate() - 30);

const range = ref({ start, end });

const formStartDate = computed(() => formatDate(range.value.start));
const formEndDate = computed(() => formatDate(range.value.end));

const myOrderList = ref({});

const getMyOrderList = async (num) => {
  const pageValue = num !== undefined ? 1 : page.value;

  try {
    console.log(pageValue);
    console.log(size.value);
    console.log(formStartDate.value);
    console.log(formEndDate.value);
    const url = `/new_api/customer/order/v2/list?page=${pageValue}&size=${size.value}&startDate=${formStartDate.value}&endDate=${formEndDate.value}`;
    const res = await axios.get(url);

    console.log(res);

    myOrderList.value = res.data.data.customerOrderList;
    pageInfo.value = res.data.data.pageInfo;

    console.log(myOrderList.value);
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  await getMyOrderList();
});

const pageInfo = ref({});

const page = ref(1);
const size = ref(10);

const updatePage = (num) => {
  page.value = num;
  getMyOrderList();
};
</script>
